export const NUM_AND_SPACE = "[0-9 ()-]+"